export default __webpack_public_path__ + "static/media/black_mode_table.18e31f2f.svg";